export const LAYOUT = {
    MOBILE_VIEWPORT_MAX: 768,
    MESSAGE_COMPACT_MAX: 500,
    PREVIEW_STACK_MAX: 300,
    DEFAULT_MEDIA_WIDTH: 380,
    DEFAULT_VIDEO_WIDTH: 480,
    MAX_VIDEO_HEIGHT: 480,
    MAX_IMAGE_HEIGHT: 480,
    COMPACT_MEDIA_WIDTH: 240,
    COMPACT_MAX_MEDIA_HEIGHT: 360,
    MIN_MEDIA_WIDTH: 100,
    MIN_PORTRAIT_MEDIA_WIDTH: 140
};

export const isMobileViewport = () => typeof window !== 'undefined' && window.innerWidth <= LAYOUT.MOBILE_VIEWPORT_MAX;

export const isCompactMessageLayout = containerWidth => {
    if (isMobileViewport()) return true;
    if (typeof containerWidth !== 'number' || Number.isNaN(containerWidth)) return false;
    return containerWidth < LAYOUT.MESSAGE_COMPACT_MAX;
};

export const isStackedPreviewLayout = containerWidth => {
    if (isMobileViewport()) return true;
    if (typeof containerWidth !== 'number' || Number.isNaN(containerWidth)) return false;
    return containerWidth < LAYOUT.PREVIEW_STACK_MAX;
};

export const getVideoAspectRatio = file => {
    if (
        file?.width &&
        file?.height &&
        file.width > 0 &&
        file.height > 0 &&
        !isNaN(file.width) &&
        !isNaN(file.height) &&
        isFinite(file.width) &&
        isFinite(file.height)
    ) {
        const calculatedRatio = file.height / file.width;
        if (calculatedRatio > 0.1 && calculatedRatio < 10 && isFinite(calculatedRatio)) {
            return calculatedRatio;
        }
    }
    if (
        file?.aspect_ratio &&
        typeof file.aspect_ratio === 'number' &&
        !isNaN(file.aspect_ratio) &&
        isFinite(file.aspect_ratio) &&
        file.aspect_ratio > 0.1 &&
        file.aspect_ratio < 10
    ) {
        return file.aspect_ratio;
    }
    return null;
};

export const calculateVideoFrameBounds = (file, explicitWidth, isCompact = isMobileViewport()) => {
    const defaultMediaWidth = isCompact ? LAYOUT.COMPACT_MEDIA_WIDTH : LAYOUT.DEFAULT_VIDEO_WIDTH;
    const resolvedVideoWidth = explicitWidth || defaultMediaWidth;
    const videoWidth = file && file.width && file.width < 100 ? 60 : resolvedVideoWidth;

    const validAspectRatio = getVideoAspectRatio(file);
    let mediaFrameWidth = videoWidth;
    let mediaFrameHeight = validAspectRatio ? Math.round(videoWidth * validAspectRatio) : null;

    const maxVideoHeight = isCompact
        ? LAYOUT.COMPACT_MAX_MEDIA_HEIGHT
        : explicitWidth
            ? null
            : LAYOUT.MAX_VIDEO_HEIGHT;
    if (maxVideoHeight && validAspectRatio && mediaFrameHeight > maxVideoHeight) {
        mediaFrameHeight = maxVideoHeight;
        mediaFrameWidth = Math.max(LAYOUT.MIN_PORTRAIT_MEDIA_WIDTH, Math.round(mediaFrameHeight / validAspectRatio));
    }

    return {
        width: mediaFrameWidth,
        height: mediaFrameHeight,
        aspectRatio: validAspectRatio,
        resolvedVideoWidth
    };
};

export const getImageAspectRatio = file => {
    if (
        file?.width &&
        file?.height &&
        file.width > 0 &&
        file.height > 0 &&
        !isNaN(file.width) &&
        !isNaN(file.height) &&
        isFinite(file.width) &&
        isFinite(file.height)
    ) {
        const calculatedRatio = file.height / file.width;
        if (calculatedRatio > 0.1 && calculatedRatio < 10 && isFinite(calculatedRatio)) {
            return calculatedRatio;
        }
    }
    if (
        file?.aspect_ratio &&
        typeof file.aspect_ratio === 'number' &&
        !isNaN(file.aspect_ratio) &&
        isFinite(file.aspect_ratio) &&
        file.aspect_ratio > 0.1 &&
        file.aspect_ratio < 10
    ) {
        return file.aspect_ratio;
    }
    return null;
};

export const calculateImageFrameBounds = (file, explicitWidth, isCompact = isMobileViewport()) => {
    const defaultMediaWidth = isCompact ? LAYOUT.COMPACT_MEDIA_WIDTH : LAYOUT.DEFAULT_MEDIA_WIDTH;
    const resolvedImageWidth = explicitWidth || defaultMediaWidth;
    const imageWidth = file && file.width && file.width < 100 ? 60 : resolvedImageWidth;

    const validAspectRatio = getImageAspectRatio(file);
    let mediaFrameWidth = imageWidth;
    let mediaFrameHeight = validAspectRatio ? Math.round(imageWidth * validAspectRatio) : null;

    const maxImageHeight = isCompact
        ? LAYOUT.COMPACT_MAX_MEDIA_HEIGHT
        : LAYOUT.MAX_IMAGE_HEIGHT;
    if (maxImageHeight && validAspectRatio && mediaFrameHeight > maxImageHeight) {
        mediaFrameHeight = maxImageHeight;
        mediaFrameWidth = Math.max(LAYOUT.MIN_PORTRAIT_MEDIA_WIDTH, Math.round(mediaFrameHeight / validAspectRatio));
    }

    return {
        width: mediaFrameWidth,
        height: mediaFrameHeight,
        aspectRatio: validAspectRatio,
        resolvedImageWidth
    };
};

